<script setup>
/**
 * App — the root layout shell.
 * ----------------------------
 * Every page shares the same chrome: a skip link, the header, the routed page
 * content, and the footer. The <RouterView> is where the active route's view
 * component is rendered. We wrap it in a <Transition> for a subtle fade
 * between pages, and key it by route path so the animation runs on each
 * navigation.
 */
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
</script>

<template>
  <!-- Accessibility: keyboard users can jump straight to the content. -->
  <a href="#main" class="skip-link">Skip to main content</a>

  <AppHeader />

  <main id="main">
    <RouterView v-slot="{ Component, route }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" :key="route.path" />
      </Transition>
    </RouterView>
  </main>

  <AppFooter />
</template>
